import {UserColor} from '~shared/models';

const hashCode = (str: string) => {
    const len = str.length;
    let hash = 0;

    for (let i = 0; i < len; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash &= hash; // Convert to 32bit integer
    }

    return hash;
};

const mod = (n: number, m: number) => {
    return ((n % m) + m) % m;
};

const colors = Object.values(UserColor);

export const getUserColor = (login: string) => {
    const num = hashCode(login);
    const length = colors.length;
    const colorIndex = mod(num, length - 1);

    return colors[colorIndex];
};
